import {apiClient} from './client';

const baseUrl = "searchable"

export const searchByName = (query: string) => {
    return apiClient.get(`${baseUrl}/search/findByNameContaining?name=${query}`)
}
